import { ReactNode } from "react"
import { Text } from "../../components/units/Text"
import { FlexWrapper } from "../../components/Wrappers/Wrappers"

interface SectionHeadingProps {
    icon: ReactNode
    title: string
}

export const SectionHeading = ({ icon, title }: SectionHeadingProps) => {
    return (
        <FlexWrapper justifyContent="flex-start" gap="5px">
            {icon}
            <Text size="xl" className="bold">{title}</Text>
        </FlexWrapper>
    )
}
